import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IPublishedConnectionDescriptionParams {
  id: string;
  description: string;
}

export class SetPublishedConnectionDescriptionRequest extends Request<IPublishedConnectionDescriptionParams, IResult> {
  constructor(params: IPublishedConnectionDescriptionParams) {
    super('setPublishedConnectionDescription', params);
  }
}
